import { render } from "./ResetPasswordForm.vue?vue&type=template&id=9f0ffc6c&scoped=true&ts=true"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=ts"

import "./ResetPasswordForm.vue?vue&type=style&index=0&id=9f0ffc6c&scoped=true&lang=scss"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f0ffc6c"]])

export default __exports__